import type { FC } from 'react';
import { useLocation } from 'react-router';
import { useOptionalCapacityManagementRoot } from 'src/apis/capacity-management/use-capacity-management-root';
import { Link } from 'src/components/navigation/link';
import { Tabs } from 'src/components/navigation/tabs';

export const OperatorsTabs: FC = () => {
  const capacityManagementRoot = useOptionalCapacityManagementRoot();
  const { pathname } = useLocation();
  return (
    <Tabs className="print:hidden">
      <Link
        to="/operators/assignments"
        isActive={
          pathname.startsWith('/operators/assignments') ||
          pathname.startsWith('/dashboard/operators/assignments')
        }
      >
        Assignments
      </Link>

      <Link to="/operators/operator-documents">Documents</Link>

      {!!capacityManagementRoot.response?.data._links?.myInvoicesV2 && (
        <Link to="/operators/invoices" data-testid="operators-invoices-tab">
          Invoices
        </Link>
      )}
    </Tabs>
  );
};
